import { DISPLAY_EVENTS, sanitizeDisplayState } from "../../services/customerDisplayChannel";

export const initialCustomerDisplayState = sanitizeDisplayState();

export const reduceCustomerDisplayEvent = (current, event) => {
  if (!event) return current;
  switch (event.type) {
    case DISPLAY_EVENTS.CART_UPDATED:
    case DISPLAY_EVENTS.PAYMENT_STARTED:
    case DISPLAY_EVENTS.PAYMENT_UPDATED:
    case DISPLAY_EVENTS.PAYMENT_COMPLETED:
    case DISPLAY_EVENTS.DISPLAY_STATE_RESPONSE:
      return event.state ? sanitizeDisplayState(event.state) : current;
    case DISPLAY_EVENTS.CART_CLEARED:
    case DISPLAY_EVENTS.SALE_CANCELLED:
      return sanitizeDisplayState({ ...current, mode: "WELCOME", lines: [], totals: {}, payment: {} });
    default:
      return current;
  }
};

